export class CountDown extends Phaser.GameObjects.Container {
  private readonly screenWidth;
  private readonly screenHeight;
  private timer;
  private index;
  private countdownLogo;
  private nextDraw;

  constructor(scene, screenWidth, screenHeight) {
    super(scene);
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    this.index = 5;
    this.addCountdown();
  }

  addCountdown() {
    this.nextDraw = this.scene.add.image(this.screenWidth / 2, this.screenHeight * 0.51, 'next_draw');
    this.nextDraw.setScale(0.9);

    this.countdownLogo = this.scene.add.sprite(this.screenWidth / 2, this.screenHeight * 0.67, 'countdown_' + this.index);
    this.countdownLogo.setDisplaySize(this.screenWidth / 4.0, this.screenHeight / 4.0);

    this.scene.tweens.add({
      delay: 0,
      targets: [this.countdownLogo],
      props: { scale: 0.6, alpha: 1 },
      duration: 100,
      yoyo: true
    });
    this.timer = this.scene.time.addEvent({
      delay: 900,
      callback: this.updateCountdown,
      callbackScope: this,
      loop: true
    });
  }

  updateCountdown() {
    // texture not loaded yet...
    if (!this.countdownLogo?.texture) return;

    this.scene.tweens.add({
      delay: 0,
      targets: [this.countdownLogo],
      props: { scale: 0.6, alpha: 1 },
      duration: 100,
      yoyo: true
    });
    this.index -= 1;

    if (this.index < 0) {
      this.scene.time.removeEvent(this.timer);
      this.scene.scene.stop('WelcomeScene');
      // this.scene.scene.start('NumberCardScene');
      this.scene.scene.start('RollDiceScene');
      return;
    } else if (this.index === 0) {
      this.countdownLogo.setTexture('countdown_' + this.index);
      this.countdownLogo.setX(this.screenWidth * 0.5);
      this.countdownLogo.setY(this.screenHeight * 0.56);
      this.countdownLogo.setDisplaySize(this.screenWidth * 0.37, this.screenHeight / 7);
      this.nextDraw.setVisible(false);
    } else {
      this.countdownLogo.setTexture('countdown_' + this.index);
    }
  }

  pauseTimer() {
    this.scene.time.paused = true;
  }

  resumeTimer() {
    this.scene.time.paused = false;
  }
}
